export enum CookieType {
  BTAG = 'bTag',
  AFF_ID = 'affId',
  SOURCE_ID = 'sourceId',
  SITE_ID = 'siteId',
  A_ID = 'aId',
  BANNER_ID = 'bannerId',
}

export enum APP_TOUR_STATUS {
  DO_NOT_SHOW_AGAIN = 'DO_NOT_SHOW_AGAIN',
  SKIP = 'SKIP',
}

export enum APP_TOUR_STEP_STATUS {
  SEEN = 'SEEN',
}
